import script from "./SelectLanguage.vue?vue&type=script&setup=true&lang=ts"
export * from "./SelectLanguage.vue?vue&type=script&setup=true&lang=ts"

import "./SelectLanguage.vue?vue&type=style&index=0&id=52eafe7c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52eafe7c"]])

export default __exports__